/* eslint-disable import/no-extraneous-dependencies */
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import Backend from 'i18next-http-backend';

import moment from 'moment';
import 'moment/locale/ru';
import 'moment/locale/zh-cn';
import 'moment/locale/fr';
import 'moment/locale/de';

moment.defineLocale('ch', { parentLocale: 'zh-cn' });
moment.locale('en');

export const defaultNS = 'translation';

if (localStorage.getItem('i18nextLng') === null) {
  localStorage.setItem('i18nextLng', 'en');
}

i18n
  .use(Backend)
  .use(initReactI18next)
  .use(LanguageDetector)
  .init({
    fallbackLng: 'en',
    debug: process.env.NODE_ENV === 'development',
    returnEmptyString: false,
    defaultNS,
  });

i18n.services.formatter?.add('DATE_LONG', (value, lng) => {
  if (!lng) {
    return '';
  }
  return moment(value).locale(lng).format('LLLL');
});

export default i18n;
